



































































































// Importing components
import BaseSideBarListItem from '@/ui/BaseSideBarListItem.vue';
// Importing functions
import {checkPermission, checkRole} from '@/ts/helpers';
import {postLogout} from '@/ts/auth/post-logout';
import {postDonation} from '@/ts/donations/post-donation';
// Importing variables
import {Success, SuccessfulAction} from '@/ts/variables';

export default {
    name: 'BaseSideBar',
    components: {
        BaseSideBarListItem,
    },
    props: {},
    data() {
        return {
            showDrop: false,
        };
    },
    computed: {
        username() { return localStorage.getItem('user'); },
        slug() { return localStorage.getItem('slug'); },
        role() { return localStorage.getItem('roles'); },
    },
    methods: {
        logout() {
            // Logging out the user
            postLogout().finally(() => {
                this.$router.push('/');
            });
        },
        permission(name) {
            // Checking if user has permission
            return checkPermission(name);
        },
        roleCheck(name) {
            return checkRole(name);
        },
        donate(id) {
            postDonation(id).then(() => {
                this.$swal.fire(Success, SuccessfulAction, 'success');
            });
        },
    },
};
